import { AppBrandIcon } from '../icons/app-brand-icon';

interface AppBrandMarkProps {
  iconSize?: number;
  className?: string;
}

/** Ícone de marca: fundo preto + carro azul (light e dark). */
export function AppBrandMark({ iconSize = 20, className = 'size-9 rounded-lg' }: AppBrandMarkProps) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center bg-black ${className}`}
      aria-hidden
    >
      <AppBrandIcon size={iconSize} className="text-accent" />
    </div>
  );
}
